module.exports = __webpack_public_path__ + "static/media/datetime.e8faea23.svg";